var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"contentContact",style:('overflow: auto; height: calc(100vh - 250px); overflow-y:scroll')},[_c('v-expand-transition',[_c('router-view')],1)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }